import { articleIsReadyForPickup } from '@/models/article';
import { isArchived, RequestWithRelations } from '@/models/request';
import { PaymentStepMessage } from '@/routes/Requests/components/StepMessage';
import {
  ArchivedStepMessage,
  TransitStepMessage,
} from '@/routes/Requests/Request/components/RequestStepMessage/components';

import { ValidationStepMessageByClient } from '../../Article/components/ArticleTaskOrStepMessage/ValidationStepMessage';

export const RequestStepMessage = ({ request }: { request: RequestWithRelations }) => {
  if (isArchived(request)) {
    return <ArchivedStepMessage request={request} />;
  }

  const articleInValidationStepByClient = request.articles.find(
    (article) =>
      article.step?.step === 'validation' &&
      request.organization.config.clientCommunication?.notifications?.enabled &&
      article.steps?.find((step) => step.id === article.step?.id)?.status === 'in-progress'
  );

  if (articleInValidationStepByClient) {
    return <ValidationStepMessageByClient article={articleInValidationStepByClient} />;
  }

  const atLeastOneItemInProgressPayment = request.articles.some(
    (article) =>
      article.step?.step === 'payment' &&
      article.steps?.find((step) => step.id === article.step?.id)?.status === 'in-progress'
  );

  if (atLeastOneItemInProgressPayment) {
    return <PaymentStepMessage request={request} />;
  }

  const atLeastOneItemInPendingClientPickup = request.articles.some(articleIsReadyForPickup);

  if (atLeastOneItemInPendingClientPickup) {
    return <TransitStepMessage request={request} />;
  }

  return null;
};
